/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'app/modules/configuration/users/user-management/services/users.service';
import { WelcomeService } from '../welcome/welcome.service';

@Component({
    selector: 'launch',
    template: '',
    standalone: false
})
export class LaunchComponent implements OnInit {
  testSessions: any[];
  customerId;

  constructor(private router: Router, public welcomeService: WelcomeService, protected usersService: UsersService) {}

  ngOnInit() {
    this.usersService.ensurePermissions().then(() => {
      this.router.navigate(['welcome']);
    });
  }
}
